<div *ngIf="!dontShow" class="cs-select cs-skin-rotate" (clickOutside)="onClickedOutside()">
  <div (click)="changeState(); focusOn();" class="cs-placeholder">
    <span *ngIf="image && selected && selected.selectImageClass" class="image {{selected.selectImageClass | lowercase}}"></span>
    <span class="text" [innerHTML]="selected.selectDisplayName"></span> <span class="dropdown-icon" [ngClass]="{'opened': state}"></span></div>
  <div class="cs-options">
    <input *ngIf="search && !lotteryService.isMobile" (keyup)="makeSearch($event)" type="text" #searchInput class="cs-search"/>
    <ul [ngClass]="{'open': state}" #selectList>
      <li *ngFor="let option of options; let i of index" (click)="selectOption(option)"
          [value]="option.selectValue" class="cs-selected">
        <span *ngIf="image && option && option.selectImageClass" class="image {{option.selectImageClass | lowercase}}"></span>
        <span class="text" [innerHTML]="option.selectDisplayName"></span>
        <span *ngIf="selected" class="selected" [ngClass]="{'check':selected.selectDisplayName === option.selectDisplayName }"></span>
      </li>
    </ul>
  </div>
</div>
